import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { TimeBlock, TimeBlockType } from './time-block'
import { timeBlockActions } from './time-block.actions'
import * as fromTimeBlock from './time-block.reducer'
import { TimeBlockService } from './time-block.service'

import { switchMap, map, switchMapTo, concatMap } from 'rxjs/operators'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'

@Injectable()
export class TimeBlockEffects extends ResourceEffects<TimeBlock> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public timeBlockService: TimeBlockService
  ) {
    super(
      fromTimeBlock.FEATURE_NAME,
      timeBlockService,
      timeBlockActions,
      actions$
    )
  }

  fetchManyByItemTypeAndId = createEffect(() =>
    this.actions$.pipe(
      ofType(timeBlockActions.fetchManyByItemTypeAndId),
      concatMap((action) =>
        this.timeBlockService
          .getTimeBlocks(action.itemId, action.timeBlockType)
          .pipe(
            map((timeBlocks) => {
              const timeBlocksBulk = timeBlocks.map((timeBlock) => ({
                ...timeBlock,
                productId:
                  action.timeBlockType == TimeBlockType.PRODUCT
                    ? action.itemId
                    : null,
                memberId:
                  action.timeBlockType == TimeBlockType.MEMBER
                    ? action.itemId
                    : null
              }))
              return normalizationActions.upsertMany({
                entities: normalizeToSchema({
                  timeBlocks: timeBlocksBulk
                })
              })
            })
          )
      )
    )
  )

  updateOneByItemTypeAndId = createEffect(() =>
    this.actions$.pipe(
      ofType(timeBlockActions.updateOneByItemTypeAndId),
      switchMap((action) =>
        this.timeBlockService
          .updateTimeBlocks(
            action.itemId,
            action.timeBlockType,
            action.entities
          )
          .pipe(
            map((timeBlocks) => {
              const timeBlocksBulk = timeBlocks.map((timeBlock) => ({
                ...timeBlock,
                productId:
                  action.timeBlockType == TimeBlockType.PRODUCT
                    ? action.itemId
                    : null,
                memberId:
                  action.timeBlockType == TimeBlockType.MEMBER
                    ? action.itemId
                    : null
              }))
              return normalizationActions.upsertMany({
                entities: normalizeToSchema({
                  timeBlocks: timeBlocksBulk
                })
              })
            })
          )
      )
    )
  )
}
